import { render, staticRenderFns } from "./_pageHandle.vue?vue&type=template&id=14198602&"
import script from "./_pageHandle.vue?vue&type=script&lang=js&"
export * from "./_pageHandle.vue?vue&type=script&lang=js&"
import style0 from "./_pageHandle.vue?vue&type=style&index=0&id=14198602&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports